import { DateRangeSelection } from 'src/models/common';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';

import { getDatesAsString } from 'src/util/common';

export const DESKTOP_MODULE_ALL_TIME_RANGE_QUERY_VALUE =
	'DesktopModuleToolbarSegmentedButtonTimeRangeSelectionButtonAll' as const;

export const resolveDesktopModuleDateFilterForQuery = (
	dateFilter: DateRangeSelection | string,
	dateTimeRangeFilter: PreconfiguredTimeRanges
): DateRangeSelection | string => {
	if (dateTimeRangeFilter === PreconfiguredTimeRanges.ALL) {
		return DESKTOP_MODULE_ALL_TIME_RANGE_QUERY_VALUE;
	}

	return dateFilter;
};

export const resolveDesktopModuleDatefieldDateFilterParameter = (
	dateFilter: DateRangeSelection | string
): string | string[] =>
	dateFilter === DESKTOP_MODULE_ALL_TIME_RANGE_QUERY_VALUE ? dateFilter : getDatesAsString(dateFilter);
